import skyImage from "../assets/sky.png";

export class Sky {
  x: number;
  y: number;
  width: number;
  height: number;
  image: HTMLImageElement;

  constructor(x: number, y: number, width: number, height: number) {
    this.x = x;
    this.y = y;
    this.width = width;
    this.height = height;

    this.image = new Image();
    this.image.src = skyImage;
  }

  draw(ctx: CanvasRenderingContext2D) {
    ctx.fillStyle = "red";
    // ctx.fillRect(this.x, this.y, this.width, this.height);
    ctx.drawImage(
      this.image,
      //   0,
      //   0,
      //   this.image.width - 300,
      //   this.image.height - 250,
      this.x,
      this.y,
      this.width,
      this.height
    );
  }
}
